import sortChoices from './sortChoices';
import createIngredientFromChoice from './createIngredientFromChoice';

//create cart item for nested ingredients
export const createIngredientsFromChoiceSetV2 = (
  choiceSet: ChoiceSetWithQuantity | NestedChoiceSetWithQuantity,
  choiceOrderingMethod: ChoiceOrderingMethod,
  items?: Items,
): CartIngredient[] => {
  const ingredients: CartIngredient[] = [];

  let freeChoicesRemaining = choiceSet.free;

  const sortedChoices = sortChoices(choiceSet.choices, choiceOrderingMethod);

  sortedChoices.forEach(choice => {
    let remainingQuantity = choice.quantity;
    let freeQuantity = 0;

    if (freeChoicesRemaining && choice.quantity) {
      freeQuantity = Math.min(freeChoicesRemaining, choice.quantity);
      freeChoicesRemaining -= freeQuantity;
      remainingQuantity = choice.quantity - freeQuantity;
    }
    const cartItems: CartIngredient[] = [];

    if (freeQuantity) {
      cartItems.push(
        createIngredientFromChoice({
          choice: {
            ...choice,
            quantity: freeQuantity,
            baseMoneyPrice: 0,
            basePointsPrice: 0,
          },
          choiceSetId: choiceSet.id,
        }),
      );
    }

    if (remainingQuantity) {
      const mimCategoryId = items ? items[choice.id].mimCategoryId : undefined;

      cartItems.push(
        createIngredientFromChoice({
          choice: {
            ...choice,
            quantity: remainingQuantity,
          },
          choiceSetId: choiceSet.id,
          mimCategoryId,
        }),
      );
    }

    // disgusting typing patch fix here
    if (
      'choiceSets' in choice &&
      (choice as NestedChoiceWithQuantity).choiceSets &&
      cartItems.length === 1
    ) {
      let nestedChoicesets: CartIngredient[] = [];
      (choice as NestedChoiceWithQuantity).choiceSets.forEach(set => {
        nestedChoicesets = [
          ...nestedChoicesets,
          ...createIngredientsFromChoiceSetV2(set, choiceOrderingMethod, items),
        ];
      });
      cartItems[0].Ingredients = nestedChoicesets;
    }

    ingredients.push(...cartItems);
  });

  return ingredients;
};
